import styled from "styled-components";
import { Link } from "react-scroll";

export const Button = styled(Link)`
  border-radius: 50px;
  background: ${({ primary }) => (primary ? "#ae0001" : "#010606")};
  white-space: nowrap;
  padding: ${({ big }) => (big ? "14px 48" : "12px 30px")};
  color: ${({ dark }) => (dark ? "#ffff" : "#fff")};
  font-size: ${({ fontbig }) => (fontbig ? "20px" : "16px")};
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
transform: scale(1);
&:hover {
  transition: all 0.5s ease-in-out;
  background: ${({ primary }) => (primary ? "#999999" : "#77eb34")};
  transform: scale(1.1);
}
`;
